<template>
  <div class="h-[44px] md:h-[90px] mx-4 md:mx-11 my-10 md:my-6 px-2 md:px-7 py-1 md:py-2 flex flex-row justify-between items-center">
    <h1 class="grow text-center">«DigiCharte» Pilotprojekt</h1>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
